import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@hyphengroup/cag-components';
import './ProvidersDescriptionPanel.scss';

const ProvidersDescriptionPanel = ({ title, description }) => (
  <div className="providers-description-panel">
    <div className="providers-description-container-wrapper">
      <div className="providers-description-row">
        <div className="providers-description">
          <Typography as="h1" weight="light" sizeFont="px32" variant="secondary" lineHeightStyle="dp43" spacing="none" marginBottom="16px">
            {title}
          </Typography>
          <Typography as="div" weight="regular" sizeFont="px14" variant="secondary" spacing="none">
            {description}
          </Typography>
        </div>
      </div>
    </div>
  </div>
);

ProvidersDescriptionPanel.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ProvidersDescriptionPanel;
